import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import {ResidencyChoiceComponent} from "./residency-choice/residency-choice.component";

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'choix-residence', component: ResidencyChoiceComponent}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
